/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.ResourceController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { BlockResources } from '../models/block-resources';

@Injectable()
export class ResourceApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public getResourcesByRoute(application: string, route: string, language: string, spinnerMessage: string = null): Observable<BlockResources[]> {
        return this.httpClient.get<BlockResources[]>(`/api/resourcestrings/${encodeURIComponent(application)}?route=${encodeURIComponent(route)}&language=${encodeURIComponent(language)}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


}
